const formattedDate = function (value: string) {
  const dateValue = new Date(value);
  return `${dateValue.toLocaleString("en-US", {
    month: "2-digit"
  })}/${dateValue.toLocaleString("en-US", {
    day: "2-digit"
  })}/${dateValue.getFullYear()}`;
};

function getFormattedDate(timeString: string) {
  const dtObject = new Date(timeString);
  const day = dtObject.getDate();
  const month = dtObject.toLocaleString("en", { month: "short" });
  const year = dtObject.getFullYear();

  const formattedTime = `${day} ${month} ${year}`;

  return formattedTime;
}

export { formattedDate, getFormattedDate };
